import type { Board } from "../../board";
import { isRemoteDoor, PRIORITY_LAST, type ProcessableThing } from "../../interfaces";
import { PhysicalThing } from "../../physicalThing";
import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";

export class Tripwire extends PhysicalThing implements ProcessableThing {
	static key = "Tripwire";

	constructor(xy: XY) {
		super(xy, false);
	}

	isVisible(): boolean {
		return false;
	}

	processTurn(board: Board): void {
		if (!board.player) return;
		if (board.player.xy.equals(this.xy)) {
			this.activate();
		}
	}

	activate(): void {
		if (!this.active) return;
		const board = this.board!;
		board.removeAtEndOfTurn(this);

		for (const neighborXY of this.xy.getAreaInSquareRadius(1)) {
			if (!board.isInBounds(neighborXY)) continue;
			for (const thing of board.getThingsAt(neighborXY)) {
				if (!thing.active) continue;
				if (thing instanceof Tripwire) {
					thing.activate();
				} else if (isRemoteDoor(thing)) {
					thing.open();
				}
			}
		}
	}

	getProcessPriority(): number {
		return PRIORITY_LAST;
	}

	static deserialize(data: any): Tripwire {
		const t = new Tripwire(deserializeXY(data.xy));
		t.visualId = data.visualId;
		return t;
	}
}
